export enum EResponseCode {
  TOO_MANY_REQUEST = 8000,
  DUPLICATE_CONNECTION = 8001,
  NO_MORE_DEVICE = 8002,
  LONE_TIME_NO_CTRL = 8003,
  CONNECTION_DISCONNECTED = 8004,
  ERROR_CONNECTION = 8005,
  DEVICE_EXPIRES = 8006,
  GAME_NOT_EXIST = 8007,
  GAME_ID_ERROR = 8008,
  GAME_ID_NULL = 8009,
  USER_TOKEN_ERROR = 8010,
  QUEUE_INFO = 8011,
  GAME_PAUSED = 8012,
  ERROR_UID = 8013,
  USER_TOKEN_EMPTY = 8014,
  NO_MORE_USAGE_TIME = 8015,
  ADD_GAME_TIME = 8018,
  PONG = 200,
  DEVICE_INFO = 8888,
}

export interface IDeviceInfo {
  mappingId: number
  uid: string
  ipInfo: null | string
  gameId: number
  gameName: string
  packageName: string
  gyro: null | string
  deviceId: number
  deviceType: number
  serverPublicIp: string
  connectStatus: number
  startTime: number
  endTime: number
  status: number
  lastDisconnectTime: null | number
  remainingTime: number
}

export interface IWsResponseData {
  code: EResponseCode
  msg: string
  data: unknown
  time: number
}

export enum ESendType {
  PING = 'ping',
  RTT = 'delay',
  QUEUE = 'queue',
  CANCEL = 'cancel',
  PAUSE = 'pause',
}
